/* src/app/fahrzeuge/fahrzeuge.component.css */
.fzg_table {
  width: 100%;
}
.day {
  text-align: center;
}
table,
th,
td {
  vertical-align: middle;
}
.td_status {
  width: 15%;
}
.fahrzeug_title h2 {
  font-size: 22px;
  color: black;
}
.td_datum {
  font-size: 15px;
}
ul li {
  margin-top: 10px;
}
.photo-categories {
  width: 100%;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  display: block;
}
.photo-categories a {
  width: 10%;
  margin: 1%;
  display: block;
  float: left;
  text-align: center;
  padding: 10px 0;
  color: #2d2e3e;
  color: red;
}
.status0 {
  background: #6e7078;
  color: #000000;
}
.status1 {
  background: #00d750;
  color: #052c02;
}
.status2 {
  background: #0e610b;
  color: #11dc2f;
}
.status3 {
  background: #fff129;
  color: #eb0120;
}
.status4 {
  background: #ff0429;
  color: #fff129;
}
.status6 {
  background: #021416;
  color: #ff0429;
}
.status6 > table tr td div.fahrzeug_title h2 {
  font-size: 22px;
  color: red;
}
.status {
  position: absolute;
  top: -5px;
  left: -5px;
  z-index: 999;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 15px;
  padding: 0px;
  font-size: 14px;
  font-weight: 900;
  opacity: 1;
  background: #2d2e3e;
  color: #2ad5dc;
}
.notifynumber {
  background-color: #ffcc5f;
  position: absolute;
  top: 0px;
  z-index: 999;
  color: black;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 15px;
  border-radius: 10px;
  padding: 0px;
  font-size: 12px;
  font-weight: 90;
  opacity: 1;
}
/*# sourceMappingURL=fahrzeuge.component-J7JYMYUT.css.map */
